// GENERATED FILE - DO NOT MODIFY
export enum ProjectEquipmentBillingCatalogCodeEn {
    EquipCode = "EQUIPCODE",
    RateType = "RATETYPE",
}

export let nameof = "ProjectEquipmentBillingCatalogCodeEn";
